<!--
    描述：造价分析模块入口页面
    时间：2020-05-15
    Created by ws
-->
<template>
	<div class="w-filter-layout analysis-index-main">
		<!-- 延迟顶部点击筛选栏 -->
		<div class="w-filter-header"
			 v-if="showFilter && !queryParams.projectId">
			<filterArea @doFilter="doSearch"
						ref="filterArea"
						:forSearch="true"></filterArea>
		</div>

		<!-- 内容区域 -->
		<div class="w-filter-content w-page-main"
			 v-if="!queryParams.projectId">
			<div class="w-page-header">
				<searchArea v-model="filterRules.projectName"
							placeholderName="工程名称"
							:showFilter="true"
							:showMore="false"
							@on-search="doSearch"
							@on-refresh="doRefresh"
							@on-filter="showFilter = !showFilter"></searchArea>
			</div>
			<!-- 表格主体 -->
			<div class="w-page-container">
				<index-list ref="projectTable"></index-list>
			</div>

		</div>

		<!-- 具体模块内容 -->
		<div class="h100 w-tabs-layout"
			 v-else>
			<transition name="fade"
						mode="out-in">
				<router-view></router-view>
			</transition>
		</div>
	</div>
</template>

<script>
import indexList from './index_list'
import { getItem, setItem, removeItem } from '@/utils/auth'

export default {
	name: 'Cost-analysis',
	components: {
		indexList,
	},
	data() {
		return {
			showFilter: true,
			searchObj: {
				pname: '',
			},
			filterRules: {
				projectName: '',
				beginDateList: [],
				projectOriginList: [],
				curArea: [],
				projectPattenList: [],
				tags: [],
			},
		}
	},
	methods: {
		// 搜索查询
		doSearch(arr) {
			// 筛选时的赋值处理
			if (arr) {
				// 日期、年份
				this.filterRules.beginDateList = [
					...arr[0].list.map((x) => x.value),
				]

				// 来源
				this.filterRules.projectOriginList = [
					...arr[1].list.map((x) => x.value),
				]

				// 地区
				this.filterRules.curArea = [...arr[2].list.map((x) => x.value)]

				// 类型
				this.filterRules.projectPattenList = [
					...arr[3].list.map((x) => x.value),
				]

				// 标签
				this.filterRules.tags = arr[4] ? arr[4].list : []
			}

			this.$refs.projectTable.queryParams = Object.assign(
				{},
				this.filterRules
			)
			this.$refs.projectTable.getlistData()
		},

		// 点击刷新
		doRefresh() {
			// 重置筛选栏
			this.$refs.filterArea.filterColumns.forEach((x) => {
				x.checkAll = x.custom ? false : true
				x.list.filter((y) => (y.checked = false))
			})
			this.$refs.filterArea.tags = []

			// 重置变量
			this.filterRules.projectName = ''
			this.filterRules.beginDateList = []
			this.filterRules.projectOriginList = []
			this.filterRules.curArea = []
			this.filterRules.projectPattenList = []
			this.filterRules.tags = []

			this.$refs.projectTable.queryParams = Object.assign(
				{},
				this.filterRules
			)
			this.$refs.projectTable.getlistData()
		},

		// 开始项目分析
		doAnalysis(isAdd) {
			// 获取选中的项目数组
			let list = this.$refs.projectTable.analysisList
			if (list.length > 0) {
				let arr = []
				list.map((x) => {
					let obj = {
						projectName: x.projectName,
						projectId: x.id,
					}
					arr.push(obj)
				})

				// 存在localStorage 中
				setItem('projectList', JSON.stringify(arr))
				// 判断当前是否在 项目列表页面，若是，默认跳转 造价总览
				let _path =
					this.$route.path === '/project-list'
						? '/cost-overview'
						: this.$route.path

				this.$router.replace({
					path: '/redirect' + _path,
					query: {
						projectId: arr[0].projectId,
					},
				})
			} else {
				this.$message.info('请选择要分析的 项目！')
			}
		},

		// 新增项目
		addProject() {
			this.$router.push({
				path: '/project-add',
			})
		},

		//删除项目
		deleteProejct() {
			let delList = this.$refs.projectTable.deleteList

			if (delList.length > 0) {
				this.$confirm('确认要删除当前数据吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						// 调用删除接口
						deteleProjects(delList)
							.then((res) => {
								this.doSearch()
								// 清空删除数组
								this.$refs.projectTable.deleteList = []

								// 判断是否有在分析的数据
								let projectList = JSON.parse(
									getItem('projectList')
								)
								if (projectList && projectList.length > 0) {
									delList.map((x) => {
										let _index = projectList.findIndex(
											(y) => y.projectId === x
										)

										if (_index > -1) {
											projectList.splice(_index, 1)
										}
									})

									if (projectList.length > 0) {
										setItem(
											'projectList',
											JSON.stringify(projectList)
										)
									} else {
										removeItem('projectList')
									}
								}
								this.$message.success('删除成功')
							})
							.catch((err) => {})
					})
					.catch(() => {})
			} else {
				this.$message.warning('请选择要删除的项目！')
			}
		},
	},
	computed: {
		// 请求参数
		queryParams() {
			return this.$route.query
		},
	},
}
</script>

<style scoped lang="less">
.analysis-index-main {
	height: 100%;
	@topH: 41px;

	.default-header {
		height: @topH;
		line-height: @topH;
		color: #409eff;
		font-weight: 700;
		font-size: 15px;
		padding: 0 10px;
		border-bottom: 1px solid #ddd;
	}

	.default-content {
		height: calc(~'100% - @{topH}');
	}

	.list-container {
		height: 530px;
	}
}
</style>

